const Config = {
 BASE:"https://storeadminbe.myschoolwizard.com/",
  FUNCTION_KEY:"ucq1t5fZl4AESKvA89uJjdpJY3U1xUthEngli8RRaZ7IAzFuGT3MXw==",
  DELHIVERY_TRACK_URL:"https://www.delhivery.com/track/package/"
}
export default Config;
